<template>
  <div class="card-stepper" color="transparent">
    <v-card class="ma-0 stepper-wrapper" style="box-shadow: none;">
      <v-container
        v-for="(step, index) in businessSteps"
        :key="step.id"
        class="step-item d-flex flex-row align-start gap-3"
      >
        <!-- steps and dots (create calss for have state in steps)-->
        <v-sheet class="d-flex flex-column align-center justify-center pa-0">
          <v-avatar
            size="40"
            color="transparent"
            :class="[
              'step-avatar',
              {
                'step-completed': isCompleted(step),
                'step-active': isActive(step),
                'step-pending': isPending(step),
              },
            ]"
            class="elevation-0 mb-1"
          >
            <v-card-text class="pa-0">{{ step.id }}</v-card-text>
          </v-avatar>

          <!-- dots line -->
          <div
            v-if="index < businessSteps.length - 1"
            class="dotted-line d-flex flex-column align-center justify-space-between my-6"
          >
            <span
              v-for="(size, i) in dotSizes"
              :key="i"
              class="dot"
              :style="{
                width: size + 'px',
                height: size + 'px',
                backgroundColor: i < stepsProgress[step.id] ? '#000' : '#CDCDCD',
              }"
            ></span>
          </div>
        </v-sheet>
        <!-- title steps -->
        <v-sheet
          class="text-content d-flex flex-column align-start justify-start pa-0 gap-3"
        >
          <v-card-text class="step-title grey--text text--darken-1 pa-0 text-body-3">
            {{ $t("step") }}{{ step.id }}
          </v-card-text>

          <v-card-text class="step-subtitle font-weight-bold pa-0">
            {{ step.subtitle }}
          </v-card-text>

          <div v-if="isCompleted(step)" class="completed-status d-flex align-center">
            <v-card-text class="completed-status pa-0 green--text">
              {{ $t("completed") }}</v-card-text
            >
            <v-icon color="green">mdi-check</v-icon>
          </div>
        </v-sheet>
      </v-container>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'BusinessStepper',
  data: () => ({
    currentStep: 1,
    stepStatus: {
      1: 'completed',
      2: 'active',
      3: 'pending'
    },
    stepsProgress: {
      1: 0,
      2: 0
    },
    taskDone: false
  }),
  computed: {
    dotSizes () {
      return [2, 2, 3, 4, 5, 6, 7, 6, 5, 4, 3, 2]
    },
    businessSteps () {
      return [
        { id: 1, subtitle: this.$t('business info') },
        { id: 2, subtitle: this.$t('accounting information') },
        { id: 3, subtitle: this.$t('build business') }
      ]
    }
  },
  methods: {
    isCompleted (step) {
      return step.id < this.currentStep
    },
    isActive (step) {
      return step.id === this.currentStep
    },
    isPending (step) {
      return step.id > this.currentStep
    },
    handleProgressStep (stepId) {
      const total = this.dotSizes.length
      const perClick = Math.floor(total / 2)
      if (this.stepsProgress[stepId] < total) {
        this.stepsProgress[stepId] += perClick
      }
    },
    decreaseProgressStep (stepId) {
      const total = this.dotSizes.length
      const perClick = Math.floor(total / 2)
      if (this.stepsProgress[stepId] > 0) {
        this.stepsProgress[stepId] -= perClick
      }
    },
    completeStep () {
      if (this.currentStep < this.businessSteps.length) {
        this.taskDone = true
        this.currentStep += 1
      } else {
        this.taskDone = false
        this.currentStep = 1
      }
    },
    previousStep () {
      if (this.currentStep > 1) {
        this.currentStep -= 1
        this.taskDone = false
      }
    }
  }
}
</script>

<style scoped>
.card-stepper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 40px 0px;
}
.stepper-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: clamp(290px, 40vw, 400px);
}
.step-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 16px;
  color: #333;
  background-color: transparent;
  transition: all 0.3s ease;
}
.step-completed {
  background-color: #000 !important;
  color: #fff !important;
  border: 5px solid #cfcece !important;
}

.step-active {
  background-color: #d9eeff !important;
  box-shadow: 0 0 0 4px #fff, 0 0 0 5.3px #0066ff !important;
}

.step-pending {
  background-color: #000 !important;
  border: 5px solid #cfcece !important;
  color: #fcfcfc !important;
}

.dotted-line {
  height: 115px;
}

.dot {
  border-radius: 50%;
  background-color: #cdcdcd;
  flex-shrink: 0;
}

.dot-completed {
  background-color: #000;
}
.text-content {
  flex: 1;
  text-align: right;
}
.step-title {
  font-weight: 600;
  font-size: 22px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: right;
  vertical-align: middle;
  color: #aaa8a8;
}

.step-subtitle {
  font-size: 22px;
  color: #000;
  text-align: right;
  vertical-align: middle;
  line-height: 100%;
}
.completed-status {
  font-size: 18px;
  line-height: 100%;
  font-weight: 600;
  color: #137333;
  text-align: right;
  vertical-align: middle;
}
@media (max-width: 758px) {
  .stepper-wrapper {
    width: clamp(260px, 40vw, 270px);
  }
}
@media (max-height: 700px) and (min-width: 900px) {
  .step-avatar {
    width: 30px;
    height: 30px;
  }
}
</style>
